import { createContext } from "react";
import { INIT_CONTEXT } from "./constants";

const SettingsResourceScheduleAdminContext = createContext(INIT_CONTEXT);

export default SettingsResourceScheduleAdminContext;